import Vue from 'vue';
import Router from 'vue-router';
import PanelV2 from '@/components/panel/PanelV2';
import constants from '@/js/constants';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'SplashHeader',
      component: () =>
        import(
          /* webpackChunkName: "splash_header" */ '@/components/v3/splash-page/components/HeaderFooter'
        ),
      children: [
        {
          path: '/',
          name: 'SplashPage',
          component: () =>
            import(
              /* webpackChunkName: "splash_v4" */ '@/components/v3/splash-page/index'
            ),
        },
        {
          path: '/autopilot',
          name: 'autopilot',
          component: () =>
            import(
              /* webpackChunkName: "hirefly_autopilot" */ '@/components/v3/splash-page/AutopilotProduct'
            ),
        },
        {
          path: '/about',
          name: 'about',
          component: () =>
            import(
              /* webpackChunkName: "about" */ '@/components/v3/splash-page/AboutPage'
            ),
        },
        {
          path: '/navigator',
          name: 'navigator',
          component: () =>
            import(
              /* webpackChunkName: "hirefly_navigator" */ '@/components/v3/splash-page/NavigatorProduct'
            ),
        },
        {
          path: '/fast-track',
          name: 'fast-track',
          component: () =>
            import(
              /* webpackChunkName: "hirefly_navigator" */ '@/components/v3/splash-page/FastTrackProduct'
            ),
        },
        {
          path: '/contact',
          name: 'Contact',
          component: () =>
            import(
              /* webpackChunkName: "contact" */ '@/components/v3/splash-page/RequestDemo'
            ),
        },
        {
          path: '/transform',
          name: 'transform',
          component: () =>
            import(
              /* webpackChunkName: "contact" */ '@/components/v3/splash-page/TransformPage'
            ),
        },
        {
          path: '/unleash',
          name: 'unleash',
          component: () =>
            import(
              /* webpackChunkName: "contact" */ '@/components/v3/splash-page/Unleash'
            ),
        },
        {
          path: '/recfest',
          name: 'recfest',
          component: () =>
            import(
              /* webpackChunkName: "contact" */ '@/components/v3/splash-page/Recfest'
            ),
        },
        {
          path: '/hrtech',
          name: 'hrtech',
          component: () =>
            import(
              /* webpackChunkName: "contact" */ '@/components/v3/splash-page/HRTech'
            ),
        },
        {
          path: '/thank-you',
          name: 'thank-you',
          component: () =>
            import(
              /* webpackChunkName: "contact" */ '@/components/v3/splash-page/ThankYou'
            ),
        },
      ],
    },
    {
      path: '/blogs',
      name: 'Blogs',
      component: () =>
        import(/* webpackChunkName: "blogs" */ '@/components/v3/blogs/Blogs'),
      children: [
        {
          path: '/blogs/engineering/:blog_id',
          name: 'Engineering',
          component: () =>
            import(
              /* webpackChunkName: "engineering" */ '@/components/v3/blogs/engineering/Engineering'
            ),
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: () =>
        import(/* webpackChunkName: "login" */ '@/components/Login'),
    },
    {
      path: '/v2/login',
      name: 'Login2',
      component: () =>
        import(/* webpackChunkName: login2 */ '@/components/Login2'),
    },
    {
      path: '/product-picker',
      name: 'product-picker',
      component: () => import('@/components/v3/splash-page/ProductPicker'),
    },
    {
      path: '/calendar',
      name: 'CalendarSetup',
      component: () =>
        import(
          /* webpackChunkName: "calendar_setup" */ '@/components/project/CalendarSetupV2/'
        ),
      meta: { requiresAuth: true },
    },
    {
      path: '/ats-settings',
      name: 'AtsSettings',
      component: () =>
        import(
          /* webpackChunkName: "ats_settings" */ '@/components/v3/ats-settings/AtsSettings/'
        ),
      meta: { requiresAuth: true },
    },
    {
      path: '/projects/new',
      name: 'CreateProject',
      component: () =>
        import(
          /* webpackChunkName: "create_project" */ '@/components/project/CreateProjectV2/'
        ),
      meta: { requiresAuth: true },
    },
    {
      path: '/projects/v2/new/:projectType',
      name: 'project-new',
      component: () => import('@/components/v2/project/Creation'),
      meta: { requiresAuth: true },
    },
    {
      path: '/projects/v2/draft/:project_id',
      name: 'project-draft',
      component: () => import('@/components/v2/project/Draft'),
      meta: { requiresAuth: true },
    },
    {
      path: '/projects/settings/v2/:project_id',
      name: 'project-detail',
      component: () => import('@/components/v2/project/Settings'),
      meta: { requiresAuth: true },
    },
    {
      path: '/autopilot-projects/new',
      name: 'AutopilotForm',
      component: () =>
        import('@/components/autopilot/onboarding-rewrite/AutopilotForm'),
      meta: { requiresAuth: true },
    },
    {
      path: '/autopilot-projects/self-serve/new',
      name: 'CreateSelfServeProject',
      component: () =>
        import(
          /* webpackChunkName: "create_project" */ '@/components/project/CreateSelfServeProject'
        ),
      meta: { requiresAuth: true },
    },
    {
      path: '/projects/edit/:id',
      name: 'UpdateProject',
      component: () =>
        import(
          /* webpackChunkName: "update_project" */ '@/components/project/UpdateProjectV2/'
        ),
      meta: { requiresAuth: true },
    },
    {
      path: '/analytics/pipeline',
      name: 'PipelinePerformance',
      component: () =>
        import(
          /* webpackChunkName: "pipeline_performance" */ '@/components/analytics/PipelinePerformance'
        ),
      meta: { requiresAuth: true },
    },
    {
      path: '/analytics/candidate',
      name: 'CandidateDemographics',
      component: () =>
        import(
          /* webpackChunkName: "candidate_demographics" */ '@/components/analytics/CandidateDemographics'
        ),
      meta: { requiresAuth: true },
    },

    {
      path: '/panel',
      name: 'Panel',
      // Panel is the most visited page. Do not lazy load.
      component: PanelV2,
      meta: { requiresAuth: true },
    },
    {
      path: '/profile',
      name: 'Profile',
      component: () =>
        import(/* webpackChunkName: "profile" */ '@/components/Profile'),
      meta: { requiresAuth: true },
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: () =>
        import(/* webpackChunkName: "checkout" */ '@/components/Checkout'),
      meta: { requiresAuth: true },
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: () =>
        import(/* webpackChunkName: "privacy" */ '@/components/Privacy'),
    },
    {
      path: '/terms-of-service',
      name: 'TermsOfService',
      component: () =>
        import(
          /* webpackChunkName: "term_of_service" */ '@/components/TermsOfService'
        ),
    },
    {
      path: '/analytics',
      name: 'Analytics',
      component: () =>
        import(
          /* webpackChunkName: "autopilot_analytics" */ '@/components/AutopilotAnalytics'
        ),
      meta: { requiresAuth: true },
    },
    {
      path: '/notifications/unsubscribe',
      name: 'email-unsubscribe',
      component: () =>
        import(
          /* webpackChunkName: "unsubscribe" */ '@/components/Unsubscribe'
        ),
    },
    {
      path: '/notifications/resubscribe',
      name: 'email-resubscribe',
      component: () =>
        import(
          /* webpackChunkName: "resubscribe" */ '@/components/Resubscribe'
        ),
    },
    {
      path: '/autopilot-onboarding',
      name: 'autopilot-onboarding',
      component: () =>
        import(
          /* webpackChunkName: "auto_pilot_landing" */ '@/components/AutoPilotLanding'
        ),
    },
    {
      path: '/demos/templates',
      name: 'candidate-email-templates',
      component: () => import('@/components/candidate/email-templates'),
      meta: { requiresAuth: true },
    },
    {
      path: '/demos/ideal-candidates',
      name: 'candidate-ideal-candidates',
      component: () => import('@/components/candidate/ideal-candidates'),
      meta: { requiresAuth: true },
    },
    {
      path: '/v1/candidates/additional_information',
      name: 'candidate-additional-information',
      component: () =>
        import('@/components/autopilot/AdditionalInformationForZendesk'),
    },
  ],
  mode: 'history',
});

router.beforeEach((to, from, next) => {
  // Canary redirect for internal users
  const { hostname } = window.location;
  const sessionEmail = localStorage.getItem('email');
  if (
    (hostname === 'hirefly.ai' ||
      hostname === 'www.hirefly.ai' ||
      hostname === 'hirefly-web-client.herokuapp.com') &&
    !sessionStorage.getItem('noRedirect') &&
    !constants.CANARY_OPT_OUT_USERS.includes(sessionEmail)
  ) {
    if (to.query.no_redirect) {
      sessionStorage.setItem('noRedirect', 'true');
    } else if (constants.SUPER_ADMIN_USERS.includes(sessionEmail)) {
      const href = window.location.href
        .replace('hirefly.ai', 'herokuapp.com')
        .replace('www', 'hirefly-web-client-canary');
      window.location.replace(href);
      return;
    }
  }

  // Auth redirect
  window.scrollTo(0, 0);
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    const session = localStorage.getItem('session');
    if (!session) {
      next({
        path: '/',
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
